import React from 'react'
import { Link } from 'react-router-dom'
import AbstractVisual from '../AbstractVisual/AbstractVisual'
import Reveal from '../Reveal/Reveal'
import './PageBanner.scss'

/**
 * Full-width dark banner with 3D artwork on the right — the single-slide
 * sibling of ServiceSpotlight, used to close a page with one clear next step.
 *
 * `highlight` is painted with the gradient and must appear verbatim in
 * `title`. `to` is an internal route.
 */
const PageBanner = ({
  eyebrow,
  title,
  highlight,
  text,
  cta,
  to,
  shape = 'ribbon',
  colors,
  className = '',
}) => {
  const at = highlight ? title.indexOf(highlight) : -1

  return (
    <section className={`page-banner ${className}`}>
      <AbstractVisual className='page-banner-visual' shape={shape} colors={colors} />
      <div className='page-banner-fade' aria-hidden='true' />

      <div className='page-banner-inner'>
        <Reveal>
          {eyebrow && <p className='page-banner-eyebrow'>{eyebrow}</p>}
          <h2 className='page-banner-title'>
            {at === -1 ? (
              title
            ) : (
              <>
                {title.slice(0, at)}
                <span className='page-banner-gradient'>{highlight}</span>
                {title.slice(at + highlight.length)}
              </>
            )}
          </h2>
          {text && <p className='page-banner-text'>{text}</p>}
          {cta && to && (
            <Link to={to} className='page-banner-link'>
              {cta}
              <span aria-hidden='true'>→</span>
            </Link>
          )}
        </Reveal>
      </div>
    </section>
  )
}

export default PageBanner
